import { z } from 'zod';

import { makeEndpoint } from '../common';

export enum DurationField {
  LABEL = 'label',
}

const DurationSchema = z.object({
  id: z.string().uuid().optional(),
  label: z.string(),
  duration: z.number(),
});

const FindDurationsByDurationSetIdResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  durations: z.array(DurationSchema),
});

export const FindDurationsByDurationSetIdEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ durationSetId }: { durationSetId: string }) => `v1/duration-set/${durationSetId}`,
  responseSchema: FindDurationsByDurationSetIdResponseSchema,
  requestSchema: z.void(),
});

const CreateDurationsForExperienceResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  durations: z.array(DurationSchema),
});

const CreateDurationsForExperienceRequestSchema = z.object({
  durations: z.array(
    z.object({
      label: z.string(),
      duration: z.number(),
    }),
  ),
});

export const CreateDurationsForExperienceEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ brandId, experienceId }: { brandId: string; experienceId: string }) =>
    `v1/brands/${brandId}/experiences/${experienceId}/durations`,
  responseSchema: CreateDurationsForExperienceResponseSchema,
  requestSchema: CreateDurationsForExperienceRequestSchema,
});

const CreateDurationsForResourceGroupResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  durations: z.array(DurationSchema),
});

const CreateDurationsForResourceGroupRequestSchema = z.object({
  durations: z.array(DurationSchema),
});

export const CreateDurationsForResourceGroupEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ brandId, resourceGroupId }: { brandId: string; resourceGroupId: string }) =>
    `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations`,
  responseSchema: CreateDurationsForResourceGroupResponseSchema,
  requestSchema: CreateDurationsForResourceGroupRequestSchema,
});

const UpdateDurationRequestSchema = z.object({
  label: z.string(),
});

export const UpdateDurationEndpoint = makeEndpoint({
  method: 'PUT',
  url: ({ durationId }: { durationId: string }) => `v1/durations/${durationId}`,
  responseSchema: z.void(),
  requestSchema: UpdateDurationRequestSchema,
});

const UpdateDurationsByExperienceIdRequestSchema = z.object({
  durations: z.array(
    z.object({
      id: z.string().uuid().optional(),
      label: z.string(),
      duration: z.number(),
    }),
  ),
});

export const UpdateDurationsByExperienceIdEndpoint = makeEndpoint({
  method: 'PUT',
  url: ({ brandId, experienceId }: { brandId: string; experienceId: string }) =>
    `v1/brands/${brandId}/experiences/${experienceId}/durations`,
  responseSchema: z.void(),
  requestSchema: UpdateDurationsByExperienceIdRequestSchema,
});

const UpdateDurationsByResourceGroupIdRequestSchema = z.object({
  durations: z.array(DurationSchema),
});

export const UpdateDurationsByResourceGroupIdEndpoint = makeEndpoint({
  method: 'PUT',
  url: ({ brandId, resourceGroupId }: { brandId: string; resourceGroupId: string }) =>
    `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations`,
  responseSchema: z.void(),
  requestSchema: UpdateDurationsByResourceGroupIdRequestSchema,
});

const FindDurationsByExperienceIdResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  version: z.string(),
  durations: z.array(DurationSchema),
});

export const FindDurationsByExperienceIdEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, experienceId, version }: { brandId: string; experienceId: string; version: string }) =>
    `v1/brands/${brandId}/experiences/${experienceId}/durations/${version}`,
  responseSchema: FindDurationsByExperienceIdResponseSchema,
  requestSchema: z.void(),
});

const FindDurationsByResourceGroupIdResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  version: z.string(),
  durations: z.array(DurationSchema),
});

export const FindDurationsByResourceGroupIdEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, resourceGroupId, version }: { brandId: string; resourceGroupId: string; version: string }) =>
    `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations/${version}`,
  responseSchema: FindDurationsByResourceGroupIdResponseSchema,
  requestSchema: z.void(),
});
